import React from "react";

export class DropDown extends React.Component {
  state = {
    isOpen: false,
    currentItem: "",
  };

  container = React.createRef();
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.container.current &&
      !this.container.current.contains(event.target)
    ) {
      this.setState({ isOpen: false });
    }
  };

  toggleOpen = () => this.setState({ isOpen: !this.state.isOpen });

  render() {
    const {
      title,
      items,
      textProperty,
      selectedItem,
      onItemSelect,
    } = this.props;
    const menuClass = `dropdown-menu${this.state.isOpen ? " show" : ""}`;
    return (
      <div
        className="dropdown"
        onClick={this.toggleOpen}
        style={{ display: "inline-flex" }}
        ref={this.container}
      >
        <button
          className="btn dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          style={{ backgroundColor: "#385EA4", color: "white" }}
        >
          {title}
        </button>

        <ul className={menuClass} aria-labelledby="dropdownMenuButton">
          {items.length &&
            items.map((item) => (
              <li
                onClick={onItemSelect ? () => onItemSelect(item) : null}
                key={item[textProperty] ? item[textProperty] : item + "_lg"}
                className={
                  item === selectedItem
                    ? "dropdown-item active"
                    : "dropdown-item"
                }
                style={{ fontSize: "1rem", cursor: "pointer" }}
              >
                {item[textProperty] ? item[textProperty] : item}
              </li>
            ))}
        </ul>
      </div>
    );
  }
}

export default DropDown;
